/* eslint operator-linebreak: 0 */
var __decorate = this && this.__decorate || function (decorators, target, key, desc) {
  var c = arguments.length,
    r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
    d;
  if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
  return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { isEqual, throttle, zip, orderBy, mapValues, debounce, invoke } from "lodash-es";
import Vue from 'vue';
import Component from 'vue-class-component';
import { CalmComputedGetter, getLayoutSlot, getOffsetRect, getVariableName, walkLayout } from "../../lib/utils";
import { INJECT_UICORE_BUS, INJECT_UICORE_DESIGNER } from "../../lib/utils/consts";
import { getMainAxisInfo, getMainAxisPos, getMainAxisRange, getRectIntersection, rect2css, zeroRect, isRectEqual, getSpaceBetweenTwoRect } from "../../lib/utils/styling";
import { getLayoutIdLUT, unescapeSlotName } from "../../lib/utils/layout";
import InsertionDropHint from './dropHints/InsertionDropHint';
import NoopDropHint from './dropHints/NoopDropHint';
import InsertEmptySlotHint from './dropHints/InsertEmptySlotDropHint';
import MakeParagraphDropHint from './dropHints/MakeParagraphDropHint';
import BlockifyDropHint from './dropHints/BlockifyDropHint';
import { VueCalmComputedData } from "../../lib/utils/vue/vueCalmComputedData";
import AbsoluteSlotDropHint from "../../lib/designer/dropHints/AbsoluteSlotDropHint";
let TargetSlotSkeleton = class TargetSlotSkeleton extends Vue {
  constructor() {
    super(...arguments);
    // #endregion
    this.isVisible = false;
    // 当前拖入区域的边框 绝对位置于editzone
    this.skeletonStyle = {};
    this.slotClientX = 0;
    this.slotClientY = 0;
    /**
     * slotContainerElement 内布局的方向
     *
     * 用于子组件拖拽。在 syncStyle 时会同步更新。
     */
    this.slotDirection = '';
    this.slotWidth = 0;
    this.slotHeight = 0;
  }
  get renderer() {
    return this.designer.renderer;
  }
  // #region comp
  // @CalmComputedGetter()
  get compPath() {
    return this.info.compPath;
  }
  // @CalmComputedGetter()
  get compInstance() {
    return this.info.compInstance;
  }
  get layout() {
    return this.designer.getCompAtPath(this.compPath);
  }
  // #endregion
  // #region slot
  // @CalmComputedGetter()
  get slotId() {
    return this.info.slotMeta.id;
  }
  get children() {
    return this.layout && getLayoutSlot(this.layout, this.slotId, false) || [];
  }
  set children(newChildren) {
    this.designer.modifyComp(this.compPath, (comp, rootLayout) => {
      if (!rootLayout || !comp) return;
      const slot = getLayoutSlot(comp, this.slotId, true);
      // 准备重新刷ID
      const existingComponents = getLayoutIdLUT(rootLayout);
      Object.keys(getLayoutIdLUT({
        type: 'any',
        children: slot
      })).forEach(k => {
        delete existingComponents[k];
      });
      // 补全ID
      walkLayout({
        type: 'any',
        children: newChildren
      }, ({
        layout
      }) => {
        var _layout$componentId;
        const rawId = ((_layout$componentId = layout.componentId) === null || _layout$componentId === void 0 ? void 0 : _layout$componentId.replace(/\d+$/, '')) || layout.type;
        const newId = getVariableName(rawId, existingComponents);
        existingComponents[newId] = true;
        if (layout.componentId !== newId) layout.componentId = newId;
      });
      // 应用
      slot.length = 0;
      slot.push(...newChildren);
    });
  }
  get slotMeta() {
    return this.info.slotMeta;
  }
  get slotContainerElement() {
    return this.info.slotContainerElement;
  }
  get isSlotFrozen() {
    return !this.slotContainerElement;
  }
  get dropHints() {
    var _this$designer;
    const ans = [];
    const prefix = `${this.compPath}/${this.slotId}/`;
    const {
      renderer
    } = this.designer;
    const draggingCompPath = this.editZoneState.currentDraggingCompPath;
    const beforeDrop = this.slotMeta.beforeDrop || (() => true);
    if (beforeDrop && (_this$designer = this.designer) !== null && _this$designer !== void 0 && (_this$designer = _this$designer.dragSource) !== null && _this$designer !== void 0 && _this$designer.layout) {
      const beforeDropResult = beforeDrop({
        layout: this.designer.dragSource.layout,
        compMeta: this.designer.dragSource.compMeta,
        currentLayout: this.layout
      });
      if (!beforeDropResult) {
        ans.push(new NoopDropHint(this, {
          compPath: this.compPath,
          description: '不能放到这里面'
        }));
        return ans;
      }
    }
    // 绝对定位布局拖入的时候就应该给定位了
    if (this.slotMeta.position === 'absolute') {
      ans.push(new AbsoluteSlotDropHint(this, {
        compPath: this.compPath,
        insertIndex: this.children.length || 0
      }));
      return ans;
    }
    if (this.children.length) {
      var _this$uc$components$w;
      // 插槽有内容
      // 对于纵向插槽的情况，可以通过在组件块左侧或者右侧放置东西，实现分列
      const allowRowInSlot = (this.slotDirection === 'column' || this.slotDirection === 'column-reversed') && beforeDrop({
        layout: {
          type: 'w-row'
        },
        compMeta: (_this$uc$components$w = this.uc.components['w-row']) === null || _this$uc$components$w === void 0 ? void 0 : _this$uc$components$w.meta
      });
      // 对于横向插槽，如果有空余区域，可以在上、下插入元素
      const allowBlockify = this.slotDirection === 'row' || this.slotDirection === 'row-reversed';
      // 然后开始搞
      this.children.forEach((child, index) => {
        var _renderer$getRefByPat;
        const compPath = prefix + index;
        const el = renderer === null || renderer === void 0 || (_renderer$getRefByPat = renderer.getRefByPath(compPath)) === null || _renderer$getRefByPat === void 0 ? void 0 : _renderer$getRefByPat.$el;
        if (!el) return; // 无效的组件！
        if (draggingCompPath === compPath) {
          ans.unshift(new NoopDropHint(this, {
            compPath,
            description: '请拖到需要放置的地方'
          }));
          return;
        }
        ans.push(new InsertionDropHint(this, {
          compPath,
          after: true
        }));
        ans.push(new InsertionDropHint(this, {
          compPath,
          after: false
        }));
        if (allowRowInSlot) {
          ans.push(new MakeParagraphDropHint(this, {
            compPath,
            place: 'before'
          }));
          ans.push(new MakeParagraphDropHint(this, {
            compPath,
            place: 'after'
          }));
        }
        if (allowBlockify) {
          ans.push(new BlockifyDropHint(this, {
            compPath,
            place: 'before'
          }));
          ans.push(new BlockifyDropHint(this, {
            compPath,
            place: 'after'
          }));
        }
      });
    }
    if (!ans.length) {
      var _renderer$getRefByPat2;
      // 插槽为空，或者没有可用的插入点
      const ucSlotInst = renderer === null || renderer === void 0 || (_renderer$getRefByPat2 = renderer.getRefByPath(this.compPath)) === null || _renderer$getRefByPat2 === void 0 || (_renderer$getRefByPat2 = _renderer$getRefByPat2.ucSlotInstances) === null || _renderer$getRefByPat2 === void 0 ? void 0 : _renderer$getRefByPat2[unescapeSlotName(this.slotId)];
      // 此时可能需要打散插槽
      const applyDefaults = ucSlotInst !== null && ucSlotInst !== void 0 && ucSlotInst.lastDRChildren ? () => ucSlotInst.applyDRContent() : undefined;
      ans.push(new InsertEmptySlotHint(this, {
        applyDefaults
      }));
    }
    return ans;
  }
  syncStyle() {
    const {
      slotContainerElement
    } = this;
    if (!slotContainerElement) {
      this.isVisible = false;
      return;
    }
    const slotClientRect = slotContainerElement.getBoundingClientRect();
    // 注意这里就得完成赋值，因为 getOffsetRect 会污染
    this.slotClientX = slotClientRect.left;
    this.slotClientY = slotClientRect.top;
    // 由于容器可能是有滚动条的，导致 slot 不能完整展示，所以这里要做个裁剪
    const visibleRect = getRectIntersection(slotClientRect, this.compInstance.$el.getBoundingClientRect());
    visibleRect.x -= slotClientRect.x;
    visibleRect.y -= slotClientRect.y;
    this.visibleRect = visibleRect;
    // 计算相对于 editZone 的位置
    const editZoneEl = this.designer.$refs.editZone.$el;
    const rect = getOffsetRect(slotClientRect, editZoneEl);
    const newStyle = rect2css(rect);
    this.slotWidth = rect.width;
    this.slotHeight = rect.height;
    this.slotRect = new DOMRect(0, 0, this.slotWidth, this.slotHeight);
    // 更新 slotDirection
    const slotMainAxisInfo = getMainAxisInfo(slotContainerElement);
    if (slotMainAxisInfo.direction !== this.slotDirection) {
      this.slotDirection = slotMainAxisInfo.direction;
    }
    this.slotIsFlex = slotMainAxisInfo.isFlex;
    this.slotIsNoWrapFlex = slotMainAxisInfo.isNoWrapFlex;
    if (!isEqual(this.skeletonStyle, newStyle)) this.skeletonStyle = newStyle;
    this.isVisible = true;
    // 最后，更新 dropHintRects
    // 很难想象 getRect里会收集到其他组件的依赖 所以不能用computed get
    const getRectArgs = {
      clientX: this.editZoneState.cursorClientX,
      clientY: this.editZoneState.cursorClientY
    };
    const newRects = this.dropHints.map(h => h.getRect(getRectArgs));
    this.dropHintRects = newRects;
  }
  get editZoneState() {
    return this.designer.editZoneState;
  }
  get shiftNoticePosition() {
    if (!this.compPath) return ''; // 根组件的插槽不需要 shift 提示
    const padding = 12;
    const {
      visibleRect
    } = this;
    const x = this.editZoneState.cursorClientX - this.slotClientX;
    const y = this.editZoneState.cursorClientY - this.slotClientY;
    if (!visibleRect) return '';
    if (x < visibleRect.x + padding) return 'Left';
    if (y < visibleRect.y + padding) return 'Top';
    if (x > visibleRect.x + visibleRect.width - padding) return 'Right';
    if (y > visibleRect.y + visibleRect.height - padding) return 'Bottom';
    return '';
  }
  get sortedDropHintRects() {
    const {
      slotRect,
      slotDirection: direction
    } = this;
    if (!this.slotIsNoWrapFlex || !direction || !slotRect) return null;
    // 这个参数单位是 px，会用于拓宽 mainAxisRange 的计算值，使得 range 更大一些，让鼠标放置点的判定更松
    const tolerance = 24;
    // 对于单向的场景，优先以主轴排序，再看副轴
    return this.dropHintRects.map((rect, index) => {
      if (!rect) return null;
      return {
        rect,
        index,
        mainAxisRange: getMainAxisRange(new DOMRect(rect.x - tolerance, rect.y - tolerance, rect.width + tolerance * 2, rect.height + tolerance * 2), slotRect, direction)
      };
    }).filter(Boolean).sort((a, b) => a.mainAxisRange.begin - b.mainAxisRange.begin);
  }
  get currentDropHintIndex() {
    const x = this.editZoneState.cursorClientX - this.slotClientX;
    const y = this.editZoneState.cursorClientY - this.slotClientY;
    let bestIndex = -1;
    let bestDistance = Infinity; // 临时用而已
    let allowingIndexes;
    // 对于单向轴的场景，优先以主轴做个筛选先
    // 注意这里有个 tolerance 参数，在 sortedDropHintRects 的 getter 里面
    if (this.slotIsNoWrapFlex && this.slotDirection && this.slotRect && this.sortedDropHintRects) {
      const curMainAxisPos = getMainAxisPos(x, y, this.slotRect, this.slotDirection);
      allowingIndexes = new Set();
      this.sortedDropHintRects.forEach(item => {
        if (!item) return;
        if (item.mainAxisRange.begin <= curMainAxisPos && item.mainAxisRange.end >= curMainAxisPos) {
          allowingIndexes.add(item.index);
        }
      });
      if (!allowingIndexes.size) allowingIndexes = undefined;
    }
    this.dropHintRects.forEach((rect, i) => {
      if (!rect) return;
      if (allowingIndexes && !allowingIndexes.has(i)) return;
      // 与这个 hint 的距离（注意，在左上方向，会是负数！！）
      const dx = x < rect.x ? x - rect.x : Math.max(0, x - (rect.x + rect.width));
      const dy = y < rect.y ? y - rect.y : Math.max(0, y - (rect.y + rect.height));
      // L2距离
      const d2 = dx * dx + dy * dy;
      if (d2 < bestDistance) {
        bestIndex = i;
        bestDistance = d2;
      }
    });
    return bestIndex;
  }
  get currentDropHint() {
    return this.dropHints[this.currentDropHintIndex];
  }
  get dropHintRect() {
    return this.dropHintRects[this.currentDropHintIndex];
  }
  mounted() {
    const editZone = this.designer.$refs.editZone;
    const syncStyleDebounced = throttle(() => {
      this.syncStyle();
    }, 100);
    // 保证拖拽停止时能够触发一次重计算
    const syncStyleDragDebounced = debounce(() => {
      this.syncStyle();
    }, 15);
    this.$watch(() => ({
      ...this.info
    }), syncStyleDebounced);
    this.$watch(() => {
      var _this$designer$pagele;
      return (_this$designer$pagele = this.designer.pagelet) === null || _this$designer$pagele === void 0 ? void 0 : _this$designer$pagele.layout;
    }, syncStyleDebounced, {
      deep: true
    });
    editZone.$el.addEventListener('scroll', syncStyleDebounced, true);
    editZone.$el.addEventListener('mouseenter', syncStyleDebounced, true);
    const handleDragEvent = ev => {
      const pos = {
        x: ev.x,
        y: ev.y
      };
      if (!isEqual(pos, this.lastDragPsoition)) {
        syncStyleDebounced();
        syncStyleDragDebounced();
      }
    };
    document.addEventListener('drag', handleDragEvent, true);
    this.$once('hook:beforeDestroy', () => {
      syncStyleDebounced.cancel();
      editZone.$el.removeEventListener('scroll', syncStyleDebounced, true);
      editZone.$el.removeEventListener('mouseenter', syncStyleDebounced, true);
      document.removeEventListener('drag', handleDragEvent, true);
    });
    this.syncStyle();
    this.$watch(() => this.currentDropHint, dropHint => {
      this.editZoneState.currentDropHint = dropHint;
    }, {
      immediate: true
    });
  }
  beforeDestroy() {
    this.editZoneState.currentDropHint = null;
  }
  get toolTipConfig() {
    var _editZone$$el, _editZone$$el$getBoun;
    const DefaultConfig = {
      css: rect2css(zeroRect),
      position: 'top',
      enable: false
    };
    // 常量配置
    const SpaceConfig = {
      enougnShiftNotice: {
        // 侧面会比较挤阈值要大一点
        vertical: 50,
        horizontal: 20,
        height: 100,
        width: 100
      },
      toolTipSpace: 100
    };
    const {
      visibleRect,
      shiftNoticePosition
    } = this;
    if (!visibleRect || !shiftNoticePosition) return DefaultConfig;
    const toolTipPosition = shiftNoticePosition.toLocaleLowerCase();
    const editZone = this.designer.$refs.editZone;
    const editZonePosition = (_editZone$$el = editZone.$el) === null || _editZone$$el === void 0 || (_editZone$$el$getBoun = _editZone$$el.getBoundingClientRect) === null || _editZone$$el$getBoun === void 0 ? void 0 : _editZone$$el$getBoun.call(_editZone$$el);
    const parentPositionx = invoke(this.compInstance, ['$parent', '$el', 'getBoundingClientRect']) || 0;
    // 插槽裁剪
    const compRect = getRectIntersection(this.slotContainerElement.getBoundingClientRect(), this.compInstance.$el.getBoundingClientRect());
    // 当前组件和editzone的间距
    const spaceBetweenCompAndEditZone = getSpaceBetweenTwoRect(compRect, editZonePosition);
    // 当前组件和父组件的间距
    const spaceBetweenCompAndParent = getSpaceBetweenTwoRect(compRect, parentPositionx);
    // 两个间距取min 得到容纳紫色提示框的宽度
    const spaceCanBeUsed = mapValues(spaceBetweenCompAndEditZone, (value, key) => Math.min(value, spaceBetweenCompAndParent[key]));
    // 对于左右就是可用宽度 对于上下就是可用高度
    // 同时判断shiftNotice的横向纵向空间是否满足要求否则就尝试弹出tooltip
    const overflowCfg = SpaceConfig.enougnShiftNotice;
    const ifOverFlow = {
      left: spaceCanBeUsed.left < overflowCfg.vertical || compRect.height < overflowCfg.height,
      right: spaceCanBeUsed.right < overflowCfg.vertical || compRect.height < overflowCfg.height,
      top: spaceCanBeUsed.top < overflowCfg.horizontal || compRect.width < overflowCfg.width,
      bottom: spaceCanBeUsed.bottom < overflowCfg.horizontal || compRect.width < overflowCfg.width
    };
    const notEnoughSpace = ifOverFlow[toolTipPosition];
    if (!notEnoughSpace) return DefaultConfig;
    let toolTipPlaceRegion = Object.entries(spaceBetweenCompAndEditZone).map(([key, value]) => {
      if (value > SpaceConfig.toolTipSpace) {
        return {
          directionSort: key === 'left' || key === 'right' ? 0 : 1,
          direction: key,
          px: value
        };
      }
    }).filter(Boolean);
    if (toolTipPlaceRegion.length === 0) return DefaultConfig;
    // 优先在上下弹出提示 剩余空间多的优先
    toolTipPlaceRegion = orderBy(toolTipPlaceRegion, ['direction', 'px'], ['desc', 'desc']);
    const {
      direction
    } = toolTipPlaceRegion[0];
    const toolTipCss = {
      left: 0,
      top: 0,
      width: compRect.width || 0,
      height: 0
    };
    let toolTipDirection = direction;
    // 对弹出tooltip的位置进行微调
    if (direction === 'bottom') {
      toolTipCss.top = compRect.height;
    }
    if (direction === 'right') {
      toolTipCss.left = compRect.width;
    }
    // 顶部或者底部弹出时 如果紫色区域在侧方向 追加偏向
    if (direction === 'bottom' || direction === 'top') {
      if (shiftNoticePosition === 'Left' || shiftNoticePosition === 'Right') {
        toolTipDirection += shiftNoticePosition;
      }
    }
    return {
      position: toolTipDirection,
      css: rect2css(toolTipCss),
      enable: true
    };
  }
  // 兜底计算description能否装在蓝色区域中
  get dropHintControl() {
    const config = {
      hideDropHint: false
    };
    const HINT_SIZE_LIMIT = {
      isBlockHint: 3000,
      '': 1000
    };
    if (!this.currentDropHint) return config;
    const area = this.currentDropHint.getAreaSize();
    if (area < HINT_SIZE_LIMIT[this.currentDropHint.hintClassName]) {
      config.hideDropHint = true;
    }
    return config;
  }
  // getDescription里可能用到getRect 会拉到奇怪的依赖 需要Calm
  get currentDescription() {
    const {
      currentDropHint
    } = this;
    if (!currentDropHint) return '';
    return currentDropHint.getDescription();
  }
  render() {
    const h = arguments[0];
    if (!this.isVisible) return null;
    const {
      currentDropHint,
      visibleRect,
      shiftNoticePosition
    } = this;
    const toolTipEnable = this.toolTipConfig.enable;
    const {
      css: toolTipCss,
      position: toolTipPlacement
    } = this.toolTipConfig;
    const {
      hideDropHint
    } = this.dropHintControl;
    return h("div", {
      "style": this.skeletonStyle,
      "class": "ucd-targetSlotSkeleton"
    }, [visibleRect && h("div", {
      "class": "ucd-targetSlotSkeleton-visibleRect",
      "style": rect2css(visibleRect)
    }, [shiftNoticePosition && h("div", {
      "class": [toolTipEnable && 'hideText', `ucd-targetSlotSkeleton-shiftNotice on${shiftNoticePosition}`]
    }, ["\u6309 Shift \u5C1D\u8BD5\u5176\u4ED6\u653E\u7F6E\u70B9"])]), currentDropHint && h("div", {
      "class": `ucd-targetSlotSkeleton-dropHint ${currentDropHint.hintClassName}`,
      "style": rect2css(this.dropHintRect)
    }, [h("div", {
      "class": [hideDropHint && 'hideText', 'ucd-targetSlotSkeleton-dropHintDescription']
    }, [this.currentDescription])]), h("a-tooltip", {
      "attrs": {
        "autoAdjustOverflow": false,
        "title": '按Shift放置紫色区域',
        "visible": toolTipEnable,
        "placement": toolTipPlacement
      }
    }, [h("div", {
      "class": 'ucd-targetSlotSkeleton-toolTipContent',
      "style": toolTipCss
    })])]);
  }
};
__decorate([CalmComputedGetter()], TargetSlotSkeleton.prototype, "layout", null);
__decorate([VueCalmComputedData('internalVisibleRect', isRectEqual, {
  default: null
})], TargetSlotSkeleton.prototype, "visibleRect", void 0);
__decorate([VueCalmComputedData('internalDropHintRects', (a, b) => a && b && a.length === b.length && zip(a, b).every(x => isRectEqual(...x)), {
  default: () => [],
  type: Array
})], TargetSlotSkeleton.prototype, "dropHintRects", void 0);
__decorate([VueCalmComputedData('internalSlotRect', isRectEqual, {
  type: DOMRect
})], TargetSlotSkeleton.prototype, "slotRect", void 0);
__decorate([CalmComputedGetter()], TargetSlotSkeleton.prototype, "shiftNoticePosition", null);
__decorate([CalmComputedGetter()], TargetSlotSkeleton.prototype, "sortedDropHintRects", null);
__decorate([CalmComputedGetter()], TargetSlotSkeleton.prototype, "currentDropHintIndex", null);
__decorate([CalmComputedGetter(isEqual)], TargetSlotSkeleton.prototype, "toolTipConfig", null);
__decorate([CalmComputedGetter(isEqual)], TargetSlotSkeleton.prototype, "dropHintControl", null);
__decorate([CalmComputedGetter()], TargetSlotSkeleton.prototype, "currentDescription", null);
TargetSlotSkeleton = __decorate([Component({
  name: 'TargetSlotSkeleton',
  inject: {
    uc: {
      from: INJECT_UICORE_BUS
    },
    designer: {
      from: INJECT_UICORE_DESIGNER
    }
  },
  props: {
    info: {
      type: Object,
      required: true
    }
  }
})], TargetSlotSkeleton);
export default TargetSlotSkeleton;
//# sourceMappingURL=TargetSlotSkeleton.js.map
